// grids API routes
const PROMO = 'contents/promo'

export { PROMO }
